<ion-header><app-navheader></app-navheader></ion-header>
<ion-content>
  <ion-label>
    <div class="title">Choisissez votre journal</div>
  </ion-label>
	<div *ngFor= "let newspaper of newspapers" class="container" [ngClass] = "newspaper.class" (click)="goToThematicFiles(newspaper.class)">
		<div class="age">{{newspaper.age}}</div><div class="logo"><ion-icon class="arrow-right-full"></ion-icon></div>
	</div>
	<app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer><app-bottom-menu [isActive]="isActivePage"></app-bottom-menu></ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" #temppopup></app-pop-up>

